<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { can } from '@/composables/useCan'

const route = useRoute()
const projectId = computed(() => route.params.project_id)

const allTabs = [
  { name: 'ProjectEdit', label: 'Edit' },
  { name: 'ProjectMembers', label: 'Members' },
  { name: 'ProjectRoles', label: 'Roles' },
  { name: 'ProjectJoinLinks', label: 'Join links' },
  { name: 'ProjectTemplates', label: 'Templates' },
  { name: 'ProjectMonitoringSettings', label: 'Monitoring' },
  { name: 'ProjectSkills', label: 'Skills' },
  { name: 'ProjectChatSettings', label: 'Chat' },
  { name: 'ProjectAgentsSettings', label: 'Agents' },
]

const tabs = computed(() =>
  allTabs.filter(tab => tab.name !== 'ProjectRoles' || can('org_role', 'read', { orgId: route.params.org_id }))
)
</script>

<template>
  <div class="flex items-start gap-6 p-3">
    <nav class="w-32 shrink-0 flex flex-col gap-0.5">
      <router-link
        v-for="tab in tabs"
        :key="tab.name"
        :to="{ name: tab.name, params: { project_id: projectId } }"
        class="rounded-md px-3 py-1.5 text-sm transition-colors"
        :class="(route.meta.navTab ?? route.name) === tab.name
          ? 'bg-muted font-semibold'
          : 'text-muted-foreground hover:bg-muted/60 hover:text-foreground'"
      >
        {{ tab.label }}
      </router-link>
    </nav>
    <div class="min-w-0 flex-1">
      <router-view></router-view>
    </div>
  </div>
</template>
